export default __webpack_public_path__ + "static/WFAM-logo-65b279b782dde20e2fd9072fa9028195.svg";